import { Empty } from "antd";
import logo from "assets/images/png/nodata.png";
import "./style.scss";

function EmptyState({ message = "No data found!", image = logo, className }) {
  return (
    <Empty
      className={`${className}`}
      description={message ?? null}
      image={image}
    />
  );
}

export default EmptyState;
